import TimeUtils from './TimeUtils';
import ApiUtils from './ApiUtils';
import React from 'react';
import DragObj from '../class/DragObj';
import DataObj from '../class/DataObj';

export default class SubTitleUtils {
  /*
   * 整理出影片字幕資料
   * */
  static createSubPlayerSubtitle(_DataObjArray) {
    console.log(_DataObjArray);
    _DataObjArray.dataArry.map((data, index) => {
      // console.log(data);
    });
  }

  /*
   * 整理出SRT 資料
   * */
  static getExportSRT_DataObject(targetData) {
    let parser = require('subtitles-parser-vtt');

    let jsonarray = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const {
        In,
        Out,
        start,
        end,
        SubtitleCaption,
        InTimecode,
        OutTimecode,
        Position,
      } = obj;

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          let isSubTop = false; //是否抬字幕
          if (parseFloat(Position) > 0 && parseFloat(Position) < 2) {
            isSubTop = true;
          }
          if (isSubTop === true) {
            newSubtitleCaption = '{\\an8}' + newSubtitleCaption;
          }

          jsonarray.push({
            id: idIndex,
            startTime: obj.InTimecode,
            endTime: obj.OutTimecode,
            text: newSubtitleCaption,
          });

          idIndex += 1;
        }
      }
    });

    // console.log(`jsonarray ${JSON.stringify(jsonarray)}`)

    return parser.toSrt(jsonarray);
  }

  /*
   * 整理出SRT 資料
   * */
  static getExport_VTT_DataObject(targetData) {
    try {
      let newcues = [];
      let idIndex = 1; 

      targetData.map((data, index) => {
        const obj = new DataObj(data);

        const { In, Out, start, end, SubtitleCaption, Position } = obj;

        // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

        const id = index + 1;

        if (
          In === '' ||
          Out === '' ||
          In === 'NaN:NaN:NaN.NaN' ||
          Out === 'NaN:NaN:NaN.NaN'
        ) {
          //不處理
        } else {
          if (In === '00:00:00:00' && Out === '00:00:00:00') {
          } else {
            let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

            let isSubTop = false; //是否抬字幕
            if (parseFloat(Position) > 0 && parseFloat(Position) < 2) {
              isSubTop = true;
            }
            if (isSubTop === true) {
              newSubtitleCaption = '{\\an8}' + newSubtitleCaption;
            }

            newcues.push({
              end: end,
              identifier: id,
              start: start,
              text: newSubtitleCaption,
              styles: '',
            });

            idIndex += 1;
          }
        }
      });

      const input = {
        meta: {
          Kind: 'captions',
        },
        cues: newcues,
        valid: true,
      };
      // const input = {
        
      //   cues: newcues,
      //   valid: true,
      // };

      //使用npm node-webvtt
      const { compile } = require('../helper/VTT/compiler');
      const result = compile(input);

      return result;
    } catch (err) {
      // console.log(`initTrack ${err}`);
      return '';
    }
  }
  /*
   * 整理出SMI 資料
   * */
  static getExport_SMI_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            startTimeMicro: start * 1000000,
            text: newSubtitleCaption,
          });

          newcues.push({
            startTimeMicro: end * 1000000,
            text: '&nbsp;',
          });

          idIndex += 1;
        }
      }
    });

    //使用
    const { generate } = require('../helper/NodeCaptions/lib/smi');
    const result = generate(newcues);

    return result;
  }

  /*
   * 整理出SMI 資料
   * */
  static getExport_TTML_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
          //不處理
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            In: In.replace('.', ':'),
            Out: Out.replace('.', ':'),
            startTimeMicro: start * 1000000,
            endTimeMicro: end * 1000000,
            text: newSubtitleCaption,
          });

          idIndex += 1;
        }
      }
    });

    //使用
    const { generate } = require('../helper/NodeCaptions/lib/ttml');
    const result = generate(newcues);

    return result;
  }

  static getExport_XML_Flash_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            InTimecode: InTimecode.replace(',', '.'),
            OutTimecode: OutTimecode.replace(',', '.'),
            text: `<sub>${newSubtitleCaption}</sub>`,
          });

          idIndex += 1;
        }
      }
    });

    let builder = require('../helper/xmlbuilder');
    let root = builder.create('tt').ele('div');
    root.declaration('1.0', 'utf-8');
    newcues.map((data, index) => {
      const { InTimecode, OutTimecode, text } = data;

      let item = root.ele('p');
      item.att('begin', InTimecode);
      item.att('end', OutTimecode);
      item.cdata(text);
    });

    let xml = root.end({ pretty: true });
    return xml;
  }

  static getExport_XML_Time_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            id: `p${index}`,
            start: start,
            end: end,
            text: newSubtitleCaption,
          });

          idIndex += 1;
        }
      }
    });

    let builder = require('../helper/xmlbuilder');
    let root = builder.create('tt');
    root.declaration('1.0', 'utf-8');
    root.att('xmlns', 'http://www.w3.org/ns/ttml');
    root.att('xmlns:ttp', 'http://www.w3.org/ns/ttml#parameter');
    root.att('ttp:timeBase', 'media');
    root.att('xmlns:tts', 'http://www.w3.org/ns/ttml#style');
    root.att('xml:lang', 'en');
    root.att('xmlns:ttm', 'http://www.w3.org/ns/ttml#metadata');

    let head = root.ele('head').ele('metadata');
    let metadata = head.ele('metadata');
    metadata.ele('ttm:title');

    let styling = head.ele('styling');
    let style = styling.ele('style');
    style.att('id', 's0');
    style.att('tts:backgroundColor', 'black');
    style.att('tts:fontStyle', 'normal');
    style.att('tts:fontSize', '16');
    style.att('tts:fontFamily', 'sansSerif');
    style.att('tts:color', 'white');

    let body = root.ele('body');
    body.att('style', 's0');
    let div = body.ele('div');

    newcues.map((data, index) => {
      const { start, end, text, id } = data;

      let item = div.ele(
        'p',
        { id: `${id}`, begin: `${start}s`, end: `${end}s` },
        text
      );
    });

    let xml = root.end({ pretty: true });
    return xml;
  }

  static getExport_DFXP_DataObject(targetData) {
    const EditingProjectInfoData = window.EditingProjectInfo;
    const InfoJsonData = JSON.parse(EditingProjectInfoData);

    let newcues = [];
    let idIndex = 1;

    let builder = require('../helper/xmlbuilder');
    let root = builder.create('tt');
    root.declaration('1.0', 'UTF-8');

    root.att('xml:lang', 'en');
    root.att('xmlns', 'http://www.w3.org/ns/ttml');
    root.att('xmlns:tts', 'http://www.w3.org/ns/ttml#styling');
    root.att('xmlns:ttp', 'http://www.w3.org/ns/ttml#parameter');
    root.att('xmlns:ttm', 'http://www.w3.org/ns/ttml#metadata');

    root.att('ttp:profile', `http://www.netflix.com/ns/ttml/profile/nflx-tt`);
    root.att('ttp:frameRate', `${TimeUtils.getFPS()}`);
    root.att('ttp:frameRateMultiplier', '1000 1001');
    root.att('ttp:dropMode', 'nonDrop');
    root.att('ttp:timeBase', 'smpte');

    //<metadata>
    let head = root.ele('head');
    let metadata = head.ele('metadata');
    metadata.ele('ttm:title', InfoJsonData['ProjectTitle']);

    //<styling>
    let styling = head.ele('styling');
    let style = styling.ele('style');
    style.att('xml:id', 'style.center');
    style.att('tts:fontFamily', 'arial');
    style.att('tts:fontSize', '100%');
    style.att('tts:fontStyle', 'normal');
    style.att('tts:fontWeight', 'normal');
    style.att('tts:backgroundColor', 'transparent');
    style.att('tts:color', 'white');
    style.att('tts:textAlign', 'center');

    //<styling>
    let layout = head.ele('layout');
    let region = layout.ele('region');
    region.att('xml:id', 'region.after');
    region.att('tts:displayAlign', 'after');
    region.att('tts:origin', '10% 50%');
    region.att('tts:extent', '80% 40%');

    let region2 = layout.ele('region');
    region2.att('xml:id', 'region.after.1');
    region2.att('tts:displayAlign', 'after');
    region2.att('tts:origin', '10% 50%');
    region2.att('tts:extent', '80% 33.88%');

    let region3 = layout.ele('region');
    region3.att('xml:id', 'region.before');
    region3.att('tts:displayAlign', 'before');
    region3.att('tts:origin', '10% 20%');
    region3.att('tts:extent', '80% 30%');

    let body = root.ele('body');
    let div = body.ele('div');

    targetData.map((data, index) => {
      const obj = new DataObj(data);
      const { In, Out, SubtitleCaption, Position } = obj;

      const id = index + 1;
      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          /**
           * 最後要打包起來的字串
           */
          let finalStringTag;

          // 先把斷行抓出來
          let subtitleFirstStep = SubtitleCaption.replace(/\r\n/g, '\n');
          const subTargetArray = subtitleFirstStep.split('\n');

          //是否抬字幕
          let isSubTop = false;
          if (parseFloat(Position) > 0 && parseFloat(Position) < 2) {
            isSubTop = true;
          }

          // p 主體
          let p = div.ele('p');
          p.att('style', 'style.center');
          p.att('region', 'region.after.center');
          p.att('begin', In.replace('.', ':'));
          p.att('end', Out.replace('.', ':'));

          // 切分出分行
          let editedSubtitle = '';
          subTargetArray.map((subObj, index) => {
            let _subtitle = '';

            if (isSubTop === true) {
              // 抬字幕
              _subtitle += '{\\an8}' + subObj;
            } else {
              // 一般字幕
              _subtitle += subObj;
            }

            if (SubtitleCaption.includes('<i>')) {
              // 處理斜體

              //  p.ele('span',{'tts:fontStyle':'italic'});
              // span.att('tts:fontStyle', 'italic');

              p.node(
                'span',
                { 'tts:fontStyle': 'italic' },
                SubTitleUtils.setItalicStyle(_subtitle, false)
              );

              _subtitle =
                `<span tts:fontStyle="italic">` +
                SubTitleUtils.setItalicStyle(_subtitle, false) +
                `</span>`;
            } else {
              // 處理一般字體
              p.text(_subtitle);
            }

            // 物件不會是最後一個
            if (index !== subTargetArray.length - 1) {
              p.node('br');

              // 最後一行之前要加 br
              _subtitle += `<br/>`;
            }

            editedSubtitle += _subtitle;
          });

          // newcues.push({
          //   id: `p${index}`,
          //   start: In.replace('.', ':'),
          //   end: Out.replace('.', ':'),
          //   text: editedSubtitle,
          // });

          // let p = div.ele(
          //   'p',
          //   {
          //     style: 'style.default',
          //     region: 'region.after.center',
          //     begin: In.replace('.', ':'),
          //     end: Out.replace('.', ':'),
          //   },
          //   editedSubtitle
          // );

          idIndex += 1;
        }
      }
    });

    // newcues.map((data, index) => {
    //   const { start, end, text, id } = data;

    //   let item = div.ele(
    //     'p',
    //     {
    //       style: 'style.default',
    //       region: 'region.after.center',
    //       begin: `${start}`,
    //       end: `${end}`,
    //     },
    //     text
    //   );
    // });

    let xml = root.end({ pretty: true });
    return xml;
  }

  static getExport_MicroDVD_SUB_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            start: parseFloat(start),
            end: parseFloat(end),
            text: newSubtitleCaption,
          });

          idIndex += 1;
        }
      }
    });

    let videoFps = TimeUtils.getFPS();
    var subsrt = require('subsrt');

    var options = { format: 'sub', fps: videoFps };
    var content = subsrt.build(newcues, options);

    return content;
  }

  static getExport_SBV_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;

    let finalStr = `[INFORMATION]\r\n[TITLE]phpjL1w4k\r\n[AUTHOR]\r\n[SOURCE]\r\n[PRG]\r\n[FILEPATH]\r\n[DELAY]0\r\n[CD TRACK]0\r\n[COMMENT]\r\n[END INFORMATION]\r\n[SUBTITLE]\r\n[COLF]&H000000,[STYLE]bd,[SIZE]25,[FONT]Arial\r\n`;

    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            start: parseFloat(start) * 1000,
            end: parseFloat(end) * 1000,
            text: newSubtitleCaption,
          });

          finalStr = `${finalStr}${InTimecode.replace(
            ',',
            '.'
          )},${OutTimecode.replace(',', '.')}${newSubtitleCaption}\n`;

          idIndex += 1;
        }
      }
    });

    let videoFps = TimeUtils.getFPS();
    var subsrt = require('subsrt');

    var options = { format: 'sbv', fps: videoFps };
    var content = subsrt.build(newcues, options);

    return `${finalStr}${content}`;
  }

  static getExport_SSA_DataObject(targetData) {
    let newcues = [];
    let idIndex = 1;
    targetData.map((data, index) => {
      const obj = new DataObj(data);

      const { In, Out, start, end, SubtitleCaption, InTimecode, OutTimecode } =
        obj;

      // console.log(`JsonData 0 ${JSON.stringify(obj)}`);

      const id = index + 1;

      if (
        In === '' ||
        Out === '' ||
        In === 'NaN:NaN:NaN.NaN' ||
        Out === 'NaN:NaN:NaN.NaN'
      ) {
        //不處理
      } else {
        if (In === '00:00:00:00' && Out === '00:00:00:00') {
        } else {
          let newSubtitleCaption = SubtitleCaption.replace(/\r\n/g, '\n');

          newcues.push({
            start: parseFloat(start) * 1000,
            end: parseFloat(end) * 1000,
            text: newSubtitleCaption,
          });

          idIndex += 1;
        }
      }
    });

    let videoFps = TimeUtils.getFPS();
    var subsrt = require('subsrt');

    var options = { format: 'ssa', fps: videoFps };
    var content = subsrt.build(newcues, options);

    return content;
  }

  /**取得間隔距離 */
  static get_findFrameSplitValue_from_local() {
    if (localStorage.getItem('findFrameSplitValue') !== null) {
      const findFrameSplitValue = localStorage.getItem('findFrameSplitValue');
      return parseFloat(findFrameSplitValue);
    } else {
      return 2;
    }
  }

  /**取得frame錯誤檢查 預設2 */
  static get_fFrameSplit_from_local() {
    if (localStorage.getItem('fFrameSplit') !== null) {
      const findFrameSplitValue = localStorage.getItem('fFrameSplit');
      return parseFloat(findFrameSplitValue);
    } else {
      localStorage.setItem('fFrameSplit', 2);
      return 2;
    }
  }

  /**把 edittable 的資料 轉換成字幕 */
  static geinitSubtitleData(videoFps) {
    const stringData = localStorage.getItem('playerEditingData');

    if (stringData !== '') {
      const stringDataJSON = JSON.parse(stringData);

      let newDateArray = [];
      if (stringDataJSON !== null) {
        stringDataJSON.map((subData, index) => {
          const { In, Out, Position } = subData;

          if (subData.SubtitleCaption) {
            let SubtitleCaption = subData.SubtitleCaption;
            // console.log(`SubtitleCaption ${SubtitleCaption}`);

            let newText = SubtitleCaption.split('\n').map((item, i) => {
              return <p key={i}>{item}</p>;
            });

            //const newSubtitleCaption = SubtitleCaption.replace('<br/>','\n');

            // console.log(newSubtitleCaption);

            // In(pin):"00:00:00.22"
            // Out(pin):"00:00:01.17"
            // ShotChange(pin):""
            // Duration(pin):0.79
            // Memo(pin):"1222"
            // Source(pin):" ROOMCA MP23"
            // SubtitleCaption(pin):"ROOMCA MP23www"
            // Length(pin):"3 3.5"
            // Position(pin):""
            newDateArray.push({
              index: index,
              In: TimeUtils.timeString_convertTo_frame(In),
              Out: TimeUtils.timeString_convertTo_frame(Out),
              SubtitleCaption: newText,
              Position: Position,
            });
          }
        });
      }
      return newDateArray;
    } else {
      return [];
    }
  }

  static getInitDragData(
    videoFps,
    frameWidth,
    frontDistance,
    playerEditingData
  ) {
    // console.log(`getInitDragData ${JSON.stringify(playerEditingData)}`);
    //const data = playerEditingData;

    let newDateArray = [];

    if (playerEditingData !== null) {
      playerEditingData.map((obj, index) => {
        const {
          In,
          Out,
          SubtitleCaption,
          Memo,
          start,
          end,
          Position,
          Source,
          ShotChange,
          Duration,
          Length,
        } = obj;

        let checkRange = 0;

        let left = 0;
        let width = 0;
        let dataObj = playerEditingData[index];
        let maxRight = 0;
        let maxLeft = 0;

        if (In !== '' && Out !== '') {
          //距離
          left =
            TimeUtils.getSubStartPosition(In, videoFps, frameWidth) +
            frontDistance;

          //寬度
          let frameDuration = TimeUtils.getDuration(In, Out, videoFps);
          width = frameDuration * frameWidth;

          //產生拖拉邊界
          //往右：下一個時間的開始點
          if (index === playerEditingData.length - 1) {
            //最後一個　沒有右邊邊界
          } else {
            const { In } = playerEditingData[index + 1];
            let nextleft =
              TimeUtils.getSubStartPosition(In, videoFps, frameWidth) +
              frontDistance;
            maxRight = nextleft;
          }

          //設定左邊界
          if (index !== 0) {
            const { In, Out } = playerEditingData[index - 1];
            let lastleft =
              TimeUtils.getSubStartPosition(In, videoFps, frameWidth) +
              frontDistance;
            let frameDuration = TimeUtils.getDuration(In, Out, videoFps);
            maxLeft = lastleft + frameDuration;
          } else {
            //第一個文字
            maxLeft = frontDistance;
          }
        }

        // In(pin):"00:00:00.22"
        // Out(pin):"00:00:01.17"
        // ShotChange(pin):""
        // Duration(pin):0.79
        // Memo(pin):"1222"
        // Source(pin):" ROOMCA MP23"
        // SubtitleCaption(pin):"ROOMCA MP23www"
        // Length(pin):"3 3.5"
        // Position(pin):""

        const dragObj = new DragObj({
          In: In,
          Out: Out,
          start: start,
          end: end,
          ShotChange: ShotChange,
          Duration: Duration,
          Memo: Memo,
          Source: Source,
          SubtitleCaption: SubtitleCaption,
          Length: Length,
          Position: Position,

          dataIndex: index,
          frontDistance: frontDistance,
          index: index,
          // dataObj:dataObj,
          maxRight: maxRight,
          maxLeft: maxLeft,
          x: left,
          width: width,
        });
        newDateArray.push(dragObj);
      });
    }
    return newDateArray;
  }

  /**
   * 初始字幕內容
   * */
  static initTrack(_WaveformView) {
    console.log('=== initTrack === ');
    try {
      let self = _WaveformView;
      _WaveformView.player.video.video.addEventListener(
        'loadedmetadata',
        function () {
          //let track = document.createElement("track");
          let track = self.player.video.video.addTextTrack(
            'subtitles',
            'English',
            'en'
          );
          //track.mode = "showing";
          track.default = true;

          //加入字幕
          SubTitleUtils.getAllVTTCueList(track, self.DataObjArray.getContent());

          //console.log(self.DataObjArray.getContent());
          //console.log(track);

          track.addEventListener('cuechange', (event) => {
            let TextTrack = event.target;
            if (TextTrack.activeCues === null || TextTrack.cues === null) {
              return;
            }

            // console.log('cuechange');
            // console.log(TextTrack.activeCues.length);

            //現在要變化的字幕檔案

            if (TextTrack.activeCues.length > 0) {
              let newTextArray = TextTrack.activeCues[0].text.split('\n');

              if (newTextArray.length > 1) {
                //多行
                let newTextArrayToString = newTextArray.join('<br/>');
                self.captionTextRef.innerHTML = newTextArrayToString;

                self.captionTextRef.innerHTML = newTextArrayToString;
              } else {
                //單行
                self.captionTextRef.innerHTML = TextTrack.activeCues[0].text;
              }

              const currentDataIndex = TextTrack.activeCues[0].id;

              //設定當前資料Index
              _WaveformView.currentDataIndex = parseFloat(currentDataIndex);
              _WaveformView.Last_currentDataIndex =
                parseFloat(currentDataIndex);

              //播放中不處理
              const { player } = _WaveformView.player.getState();
              if (player.paused === true) {
                // console.log('cuechange 更新表格');
                //更新表格
                _WaveformView.hotTableComponent.current.hotInstance.loadData(
                  _WaveformView.DataObjArray.getContent()
                );

                const currentRowData =
                  _WaveformView.DataObjArray.getObj(currentDataIndex);
                //console.log(currentRowData);
                const { Position } = currentRowData;
                _WaveformView.subMove(Position);
              }

              if (player.paused === false) {
                //更新位置
                const currentRowData =
                  _WaveformView.DataObjArray.getObj(currentDataIndex);
                const { Position } = currentRowData;
                _WaveformView.subMove_justMove(Position);

                _WaveformView.Last_currentDataIndex = currentDataIndex;

                _WaveformView.hotTableComponent.current.hotInstance.updateSettings(
                  {
                    contextMenu: true,
                  }
                );

                // _WaveformView.hotTableComponent.current.hotInstance.selectCell(parseInt(currentDataIndex, 10), parseInt(0, 10));
                //_WaveformView.setCellColorAtRunTime(currentDataIndex);
              }
            } else {
              self.captionTextRef.innerHTML = '';
            }

            //單行
          });
        },
        true
      );
    } catch (err) {
      // console.log(`initTrack ${err}`);
    }
    // console.log('=== end of initTrack === ');
  }

  /**
   * 全部更新
   * 規則
   * 1.DataObjArray 與 當前字幕數量一致的話 => 全部更新
   * 2.DataObjArray 少於 字幕數量 => 輪巡 字幕 然後把尾部的資料 都填空
   * 3.DataObjArray 大於 字幕數量 => 把少於的數量先補到字幕裡面，然後全部更新
   * */
  static updateAllTrack(_WaveformView) {
    //console.log("=== updateAllTrack === ");
    try {
      //當前資料
      const DataObjArray = _WaveformView.DataObjArray.getContent();

      //字幕列表
      let TextTrack = _WaveformView.player.video.video.textTracks[0];

      //console.log(TextTrack);

      let TextTrackList = TextTrack.cues;

      let indexId = 0;

      if (DataObjArray.length === TextTrackList.length) {
        // console.log("全部更新");
      } else if (DataObjArray.length < TextTrackList.length) {
        // console.log('輪巡 字幕 然後把尾部的資料 都填空');
        //少於 字幕數量 => 輪巡 字幕 然後把尾部的資料 都填空
        const needAddCount = TextTrackList.length - DataObjArray.length;

        // 進行移除
        for (var i = 0; i < needAddCount; i++) {
          let removeIndex = DataObjArray.length + i;

          let updateTarget = TextTrackList.getCueById(`${removeIndex}`);

          TextTrack.removeCue(updateTarget);
        }
      } else if (DataObjArray.length > TextTrackList.length) {
        // console.log('要補到TextTrackList裡面 的cue數量');
        //要補到TextTrackList裡面 的cue數量
        const needAddCount = DataObjArray.length - TextTrackList.length;

        // 進行新增
        let i = 0;
        for (i = 0; i < needAddCount; i++) {
          let addIndex = TextTrackList.length + i;

          let newVTTCue = new VTTCue(0, 0, '');
          newVTTCue.id = `${addIndex}`;
          TextTrack.addCue(newVTTCue);
        }
        // console.log('進行新增');
        // console.log(TextTrackList);
        // console.log(DataObjArray);
      }

      //更新字幕
      DataObjArray.forEach((data) => {
        //進行更新
        SubTitleUtils.updateTrack(_WaveformView, indexId);

        indexId++;
      });
    } catch (err) {
      // console.log(`updateAllTrack error ${err}`);
    }
    //console.log("=== end of updateAllTrack ===");
  }

  /**
   * 更新單一
   * */
  static updateTrack(_WaveformView, index) {
    // console.log("=== updateTrack === ");
    const newDataObj = _WaveformView.DataObjArray.getObj(index); //取得資料

    //console.log("newDataObj: " + JSON.stringify(newDataObj));
    // let updateTarget = _WaveformView.player.video.video.textTracks[0].cues[index];
    let TextTrack = _WaveformView.player.video.video.textTracks[0];

    //console.log(TextTrack);

    let TextTrackList = TextTrack.cues;
    let updateTarget = TextTrackList.getCueById(`${index}`);

    //進行更新
    const NewVTTCue = SubTitleUtils.getNewVTTCue(newDataObj, index);
    // console.log(NewVTTCue);
    // console.log(updateTarget);
    updateTarget.startTime = NewVTTCue['startTime'];
    updateTarget.endTime = NewVTTCue['endTime'];
    updateTarget.text = NewVTTCue.text;

    //console.log("=== end of updateTrack ===");
  }

  /**
   * 設定字幕內容
   * */
  static getAllVTTCueList(track, DataObjArray) {
    //console.log("=== getAllVTTCueList ===");

    //{
    // "In":"00:00:18.11",
    // "InTimecode":
    // "00:00:18,458",
    // "start":18.458333333333332,
    // "Out":"NaN:NaN:NaN.NaN",
    // "OutTimecode":"NaN:NaN:NaN,NaN",
    // "end":null,"Duration":"NaN","ShotChange":"","Memo":"","Source":"","SubtitleCaption":"What's your family name?","Length":"24","LengthTitle":"24","Position":"","CPS":-1.3,"DurationTitle":"-18.46\n(-1.3)"}

    let indexId = 0;
    DataObjArray.forEach((data) => {
      track.addCue(SubTitleUtils.getNewVTTCue(data, indexId));

      //  if(
      //      data.start ===  0 ||
      //      data.end === 0 ||
      //      data.SubtitleCaption === "" ||
      //      data.In === "" ||
      //      data.Out === "" ||
      //      data.InTimecode === "" ||
      //      data.OutTimecode === "" )
      //  {
      //      //不加
      //      track.addCue(newVTTCue);
      //  }else{
      //      track.addCue(newVTTCue);
      //  }

      indexId++;
    });
    //console.log("=== end of getAllVTTCueList ===");
  }

  /**
   * 創造一個新的CUE物件
   * */
  static getNewVTTCue(data, indexId) {
    try {
      let startTime = 0;
      let endTime = 0;
      let displaySub = '';

      if (
        isNaN(parseFloat(data.start)) === false ||
        isNaN(parseFloat(data.end)) === false
      ) {
        if (parseFloat(data.start) > 0 && parseFloat(data.end) > 0) {
        }
      }

      //確認 start 跟 end 都合格 才新增上去
      if (
        isNaN(parseFloat(data.start)) === false &&
        isNaN(parseFloat(data.end)) === false
      ) {
        //確認 結束時間 大於 開始時間
        if (parseFloat(data.start) < parseFloat(data.end)) {
          startTime = data.start;
          endTime = data.end;
          displaySub = data.SubtitleCaption;
        }
      }

      let newVTTCue = new VTTCue(startTime, endTime, displaySub);
      newVTTCue.id = `${indexId}`;

      return newVTTCue;
    } catch (err) {
      // console.log(`getNewVTTCue error ${err}`);
    }
  }

  /**
   * 取得 Detial Style
   * */
  static async get_detialStyle() {
    if (window.EditingProjectInfo) {
      const EditingProjectInfoData = window.EditingProjectInfo;
      const InfoJsonData = JSON.parse(EditingProjectInfoData);

      const { Project } = InfoJsonData;
      const jsonData = await ApiUtils.post_sql(
        `${ApiUtils.post_Style_GetStyleById}`,
        {
          qfStyleId: Project['fStyleId'],
        }
      );
      return jsonData;
    }
  }

  /**
   * 加入或是移除斜體字
   * @param {*} orginString 原字串
   * @param {*} addOrRemove true加入 false刪除
   * @returns
   */
  static setItalicStyle(orginString, addOrRemove) {
    if (addOrRemove) {
      return `<i>${orginString}</i>`;
    } else {
      return orginString.replace('<i>', '').replace('</i>', '');
    }
  }
}



// WEBPACK FOOTER //
// ./src/helper/SubTitleUtils.js